export default "__VITE_ASSET__yPJhTZEp__"